import { Dialog,Input,TableContainer,TableRow,TableBody,Grid,InputLabel,Select,FormControlLabel,Paper,Table,TableHead,TableCell,TextareaAutosize, DialogTitle,Checkbox, DialogContent, TextField, Button, MenuItem } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';

import { LoadingButton, TabPanel } from "@mui/lab"
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { useRef, useState } from 'react';
import Div from '@jumbo/shared/Div';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
const validationSchema = Yup.object().shape({
    FL_BANK_CODE: Yup.string().required('Bank is required'),
    FL_TRANS_DATE: Yup.string().required('Date is required'),
    // narration: Yup.string().required('Narration is required'),
  });
const EditSaleTXN = ({trParty,editabletrdetail,setEditabletrdetail,open,setOpen})=>{
  // console.log(editabletrdetail.detlist);
  const[stoneDetail,setStoneDetail] = useState(editabletrdetail?.detlist || [])
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const swal = useSwalWrapper();


  const handleCellDoubleClick = (index, field, value) => {
    setEditingIndex(index);
    setEditedValues({ ...editedValues, [field]: value });
  };

  const handleInputChange = (field, value) => {
    setEditedValues({ ...editedValues, [field]: value });
  };

  const handleSaveButtonClick = () => {
    // Reverse calculate the values based on the edited FL_AMT2
    // You need to implement your calculation logic here
    // let stone= stoneDetail?.filter(s=>s.FL_STONE_ID==editingIndex)[0];
    // console.log(stone);
    // let amt1= Number(editedValues?.FL_AMT2)/editabletrdetail?.FL_CONV_RATE
    // let salerate= amt1/stone.FL_WGT
    // console.log(
    //   {FL_AMT1:amt1,
    //   FL_SALERATE: salerate,
    //   FL_SALEDISC:100-( salerate*100/ stone?.FL_RAP_PRICE_US)
    //   }
    // );
    let Std = stoneDetail.map(sd=> 
    {if(sd.FL_STONE_ID==editingIndex){
      // alert()
      return  ({...sd,FL_AMT2:Number(editedValues?.FL_AMT2),FL_AMT1:Number(editedValues?.FL_AMT2)/editabletrdetail?.FL_CONV_RATE,
        FL_SALERATE: ((Number(editedValues?.FL_AMT2)/editabletrdetail?.FL_CONV_RATE)/sd.FL_WGT),
        FL_SALEDISC:100-( ((Number(editedValues?.FL_AMT2)/editabletrdetail?.FL_CONV_RATE)/sd.FL_WGT)*100/ sd?.FL_RAP_PRICE_US)
        })}
        else{
          return sd
        }
  }
  )
    setStoneDetail(Std)
    // console.log('Edited values:', editedValues?.FL_AMT2,editabletrdetail?.FL_CONV_RATE);

    // Clear editing state
    setEditingIndex(null);
    setEditedValues({});
  };
    const handleSubmitData= async(val)=>{
      let formData = {
        FL_ADAT_FLG:val?.FL_ADAT_FLG,
        FL_BANK_CODE:val?.FL_BANK_CODE,
        FL_BILL_NO:val?.FL_BILL_NO,
        FL_BROKER_PARTY:val?.FL_BROKER_PARTY,
        FL_BROKER_PER:val?.FL_BROKER_PER,
        FL_BUSINESS_TYPE:val?.FL_BUSINESS_TYPE,
        FL_CERTIFICATE_CHARGES:val?.FL_CERTIFICATE_CHARGES,
        FL_CONV_RATE:val?.FL_CONV_RATE,
        FL_CURR_CODE:val?.FL_CURR_CODE,
        FL_DIAMOND_TYPE:val?.FL_DIAMOND_TYPE,
        FL_DISCOUNT_CHRGES:val?.FL_DISCOUNT_CHRGES,
        FL_NARRATION:val?.FL_NARRATION,
        FL_OTHER_CHRGES:val?.FL_OTHER_CHRGES,
        FL_PARTY_CODE:val?.FL_PARTY_CODE,
        FL_SHIPING_CHRGES:val?.FL_SHIPING_CHRGES,
        FL_SHIP_BY:val?.FL_SHIP_BY,
        FL_TERM_CODE:val?.FL_TERM_CODE,
        FL_TRACKING_NO:val?.FL_TRACKING_NO,
        FL_TRANS_DATE:val?.FL_TRANS_DATE,
        FL_TRANS_TYPE:val?.FL_TRANS_TYPE,
        FL_TRANS_NO:val?.FL_TRANS_NO,
        FL_WAT_PER:val?.FL_WAT_PER,
        is_p:val?.is_p?'Y':'N'}
      await jwtAuthAxios.post('/transation/polishOutwardUpdate/'+val?.FL_TRANS_NO,{...formData,stoneDetail}).then(res=>{
        swal.fire({
          icon: 'success',
          text: res.data.message,
        })
        setOpen(false)
      }).catch(e=>swal.fire({
        icon: 'error',
        text: e,
      }))
        }
       
const addstoneHandler= async()=>{
  let stonID =  await prompt('Please Enter Stone ID');
  if(stonID){
    await jwtAuthAxios.post('search/stoneUser',{stoneCert:stonID}).then(res=>{
      if(res.data?.result[0]?.STATUS =='A'){
        let saler = res.data?.result[0]?.RAP_PRICE*(100-res.data?.result[0]?.ASK_DISC)/100;
        let amt1=saler*res.data?.result[0]?.CARATS
        setStoneDetail([...stoneDetail,{...res.data?.result[0],TYPE:"NEW",FL_STONE_ID:res.data?.result[0]?.STONE,FL_WGT:res.data?.result[0]?.CARATS,FL_RAP_PRICE_US:res.data?.result[0]?.RAP_PRICE,FL_SALEDISC:res.data?.result[0]?.ASK_DISC,FL_SALERATE:saler,FL_AMT1:amt1,FL_AMT2:amt1*editabletrdetail?.FL_CONV_RATE}])
      } else{
        alert('Stone is not available')
      }
    })
  }
}
       
    return (<Dialog open={open} onClose={()=>setOpen(false)} maxWidth='lg'>
        <DialogTitle>Update Sold Shipping Information</DialogTitle>
        <DialogContent >
        <Div>
        <Formik initialValues={editabletrdetail}  validationSchema={validationSchema}  onSubmit={handleSubmitData}>
              {({ values, resetForm,setFieldValue,validateForm, isSubmitting ,errors,touched}) => (
                // <Form  onSubmit={handleSubmit} >
                <> <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel>Select Bank</InputLabel>
                    <Field size="small" name="FL_BANK_CODE" InputLabel="Select Bank" as={Select} fullWidth>
                      <MenuItem value="">Select Select Bank</MenuItem>
                      {trParty?.leadgerdetail?.map(item => <MenuItem key={item.ACODE} value={item.ACODE}>{item.ANAME}</MenuItem>)}
                    </Field>
                    {errors.FL_BANK_CODE &&  (
                    <div className="error">{errors.FL_BANK_CODE}</div>
                  )}
                  </Grid>
                  <Grid item  xs={12} lg={6}>
                    <Field name="FL_CURR_CODE" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Currency Type" fullWidth>
                      {trParty?.CURR?.map((option) => (
                        <MenuItem key={option.FL_CURRENCY_ID} fname={option.FL_CURRENCY_NAME} value={option.FL_CURRENCY_ID}>
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <Field name="FL_CONV_RATE" disabled as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} type="number" label="Conv Rate" fullWidth />
                  </Grid>
                </Grid>
                  <Field name="FL_TERM_CODE" as={TextField} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} style={{ margin: '5px 0' }} select label="Payment Term" fullWidth>
                    {trParty?.TERM?.map((option) => (
                      <MenuItem key={option.FL_TERM_CODE} color='primary' value={option.FL_TERM_CODE}>
                        {option.FL_TERM_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                  <Grid container columnSpacing={2}>
                    <Grid item xs={12} lg={6}>
                  <Field name="FL_SHIP_BY" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Ship By" fullWidth>
                    {trParty?.SHIPPEDBY?.map((option) => (
                      <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                        {option.FL_PARA_VALUE}
                      </MenuItem>
                    ))}
                  </Field>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                      <Field name="FL_TRANS_DATE"  as={TextField} type="date"  style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Date" fullWidth />
                      {errors.FL_TRANS_DATE &&  (
                    <div className="error">{errors.FL_TRANS_DATE}</div>
                  )}
                  </Grid>
                    <Grid item xs={12} lg={6}>
                      <Field name="FL_WAT_PER" disabled={!values?.is_p} as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Vat Charge(%)" fullWidth />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Field name="FL_SHIPING_CHRGES" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shiping Charge(AMT)" fullWidth />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Field name="FL_CERTIFICATE_CHARGES" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Cert. Charge(AMT)" fullWidth />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Field name="FL_OTHER_CHRGES" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="OtherCharge(AMT)" fullWidth />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Field name="FL_DISCOUNT_CHRGES" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Discount(-AMT)" fullWidth />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Field name="FL_TRACKING_NO" InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} as={TextField} style={{ margin: '5px 0' }} label="Shipping Number" fullWidth />
                    </Grid>
                  </Grid>
                  <InputLabel>Naration</InputLabel>
                <Field size="small"
                      component={TextareaAutosize}
                      name="FL_NARRATION"
                      label="Naration"
                      minRows={3}
                      onChange={(e)=>setFieldValue( 'FL_NARRATION', e.target.value)} 
                      style={{width:'100%'}}
                      fullWidth                      
                      />
                  <Field
                    name="is_p"
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...field}
                            onClick={()=>values?.is_p || null ? setFieldValue('wat_per', 0):setFieldValue('wat_per', trParty?.TAX?.FL_TAX_PER)}
                            style={{ margin: '5px 0' }}
                            size="small"
                          // Add any other Checkbox props here
                          />
                        }
                        label="IS P"
                        fullWidth
                      />
                    )}
                  />
                 <LoadingButton loading={isSubmitting}  variant="contained" color='primary' sx={{ display: 'block', marginLeft: 'auto', mt: 3 }} onClick={addstoneHandler} >ADD Stone</LoadingButton>
            <TableContainer sx={{mt:3}}  component={Paper}>
        <Table border={1} size='small'>
          <TableHead>
            <TableRow>
              <TableCell>StoneID</TableCell>
              <TableCell>WGT</TableCell>
              <TableCell>Rap</TableCell>
              <TableCell>Disc</TableCell>
              <TableCell>Rate($)</TableCell>
              <TableCell>AMT($)</TableCell>
              <TableCell>AMT(RMB)</TableCell>
              {/* <TableCell>Is Approved</TableCell> */}
              <TableCell align='right'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {stoneDetail.map((st, index) => (
          <TableRow sx={{bgcolor:st.TYPE == "NEW" && '#3153721f'}} key={st.FL_STONE_ID}>
            <TableCell>{st.FL_STONE_ID}</TableCell>
            <TableCell>{st.FL_WGT?.toFixed(2)}</TableCell>
            <TableCell>{st.FL_RAP_PRICE_US?.toFixed(2)}</TableCell>
            <TableCell>{st.FL_SALEDISC?.toFixed(2)}</TableCell>
            <TableCell>{st.FL_SALERATE?.toFixed(2)}</TableCell>
            <TableCell>{st.FL_AMT1?.toFixed(2)}</TableCell>
            <TableCell>{editingIndex === st.FL_STONE_ID ? (
              <Input
                value={editedValues['FL_AMT2']}
                type='number'
                onChange={(e) => handleInputChange('FL_AMT2', e.target.value)}
              />
            ) : st.FL_AMT2?.toFixed(2)}</TableCell>
            <TableCell align='right'>
              {editingIndex === st.FL_STONE_ID ? (
                <Button variant='contained' size='small' onClick={handleSaveButtonClick}>Save</Button>
              ) : (
                <Button variant='contained' size='small' onClick={() => handleCellDoubleClick(st.FL_STONE_ID, 'FL_AMT2', st.FL_AMT2)}>Edit</Button>
              )}
            </TableCell>
          </TableRow>
        ))}
       
            </TableBody></Table></TableContainer> 
             <LoadingButton loading={isSubmitting}  variant="contained" color='primary' sx={{ display: 'block', marginLeft: 'auto', mt: 3 }} disabled={!JSON.stringify(errors) == JSON.stringify({})} type="submit" onClick={async()=> JSON.stringify(await validateForm()) == JSON.stringify({}) && handleSubmitData(values)} >Update</LoadingButton>
                  </>
                //  </Form>
              )}
            </Formik></Div>

            </DialogContent></Dialog>)
}

export default EditSaleTXN